import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useParams} from "react-router-dom";

export default function ResearcherDetail(prop) {
    let {slug} = useParams();

    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);
    let [awardListing, setAwardListing] = React.useState(null);
    let [certificateListing, setCertificateListing] = React.useState(null);
    let [completedListing, setCompletedListing] = React.useState(null);
    let [educationListing, setEducationListing] = React.useState(null);
    let [intellectualListing, setIntellectualListing] = React.useState(null);
    let [ongoingListing, setOngoingListing] = React.useState(null);
    let [trainingListing, setTrainingListing] = React.useState(null);
    let [workListing, setWorkListing] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resDetail = await getDetail();
                if(prop !== null && prop.lang === 'en') {
                    resDetail.position = resDetail.position_en;
                    resDetail.phone = resDetail.phone_en;
                    resDetail.belongto.title = resDetail.belongto.title_en;
                }

                if(resDetail) {
                    setDetail(resDetail);

                    let title = (prop.lang === 'en' ? 'Researcher':'ข้อมูลนักวิจัย/ผู้เชี่ยวชาญ') + ' - ' + (resDetail.prefix?.title + ' ' + resDetail.firstname + ' ' + resDetail.lastname) + ' | NCSA';
                    document.title = title;
                    const elDesc = document.querySelector("meta[name='description']");
                    elDesc.setAttribute('content', title);
                    const elOgTitle = document.querySelector("meta[property='og:title']");
                    elOgTitle.setAttribute('content', title);
                    const elOgDesc = document.querySelector("meta[property='og:description']");
                    elOgDesc.setAttribute('content', title);
                    const elOgImage = document.querySelector("meta[property='og:image']");
                    elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
                    const elOgUrl = document.querySelector("meta[property='og:url']");
                    elOgUrl.setAttribute('content', window.location.href);

                    let awardResult = await getAward(resDetail.id);
                    setAwardListing(awardResult);
                    let certificateResult = await getCertificate(resDetail.id);
                    setCertificateListing(certificateResult);
                    let completedResult = await getCompleted(resDetail.id);
                    setCompletedListing(completedResult);
                    let educationResult = await getEducation(resDetail.id);
                    setEducationListing(educationResult);
                    let intellectualResult = await getIntellectual(resDetail.id);
                    setIntellectualListing(intellectualResult);
                    let ongoingResult = await getOngoing(resDetail.id);
                    setOngoingListing(ongoingResult);
                    let trainingResult = await getTraining(resDetail.id);
                    setTrainingListing(trainingResult);
                    let workResult = await getWork(resDetail.id);
                    setWorkListing(workResult);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/researcherBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/researcher/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getAward(id) {
        const response = await fetch(Config.apiUrl +'/researcherAward/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCertificate(id) {
        const response = await fetch(Config.apiUrl +'/researcherCertificate/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCompleted(id) {
        const response = await fetch(Config.apiUrl +'/researcherCompleted/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getEducation(id) {
        const response = await fetch(Config.apiUrl +'/researcherEducation/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getIntellectual(id) {
        const response = await fetch(Config.apiUrl +'/researcherIntellectual/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getOngoing(id) {
        const response = await fetch(Config.apiUrl +'/researcherOngoing/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getTraining(id) {
        const response = await fetch(Config.apiUrl +'/researcherTraining/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getWork(id) {
        const response = await fetch(Config.apiUrl +'/researcherWork/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                researcherId: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'researcher_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Researcher':'ข้อมูลนักวิจัย/ผู้เชี่ยวชาญ'}</span>
                    </h1>
                    <p data-aos="fade-in">
                        <NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / <NavLink to='#'>{prop.lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</NavLink> / <NavLink to={ (prop.lang === 'en' ? '/en':'') + "/researcher"}>{prop.lang === 'en' ? 'Researcher':'ข้อมูลนักวิจัย/ผู้เชี่ยวชาญ'}</NavLink>
                    </p>
                </div>
            </div>

            <div className="section">
                <div className="container " data-aos="fade-in">
                    <div className="content">
                        <div className="card-infos" data-aos="fade-in">
                            <h3 className="fs-20">{detail?.prefix?.title + ' ' + detail?.firstname + ' ' + detail?.lastname}</h3>
                            <h4 className="fs-16 text-info">{detail?.prefix?.title_en + ' ' + detail?.firstname_en + ' ' + detail?.lastname_en}</h4>

                            <hr className="mb-4" />

                            <div className="row g-2">
                                <div className="col-12">
                                    <ul className="infos-list m-0">
                                        {
                                            detail?.belongto?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Belong to' : 'สังกัด'} :</h6>
                                                    <p>{detail?.belongto?.title}</p>
                                                </li> : ''

                                        }

                                        {
                                            detail?.position ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Position' : 'ตำแหน่งทางวิชาการ'} :</h6>
                                                    <p dangerouslySetInnerHTML={{__html: detail?.position.replace(/\n/g, "<br />")}}></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.email ?
                                                <li>
                                                    <h6>Email :</h6>
                                                    <p><a className="link-primary"
                                                          href={'mailto:' + detail?.email2}>{detail?.email}</a></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.orcid ?
                                                <li>
                                                    <h6>ORCID iD :</h6>
                                                    <p><a className="link-primary" href={detail?.orcid} target="_blank">{detail?.orcid}</a></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.contact ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Contact Location':'สถานที่ติดต่อ'} :</h6>
                                                    <p dangerouslySetInnerHTML={{__html: detail?.contact.replace(/\n/g, "<br />")}}></p>
                                                </li> : ''
                                        }
                                    </ul>
                                </div>

                                <div className="col-12">
                                    <hr className="my-md-3 my-2" />
                                </div>

                                <div className="col-12">
                                    <ul className="infos-list m-0">

                                        {
                                            detail?.address ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Address':'ที่อยู่'} :</h6>
                                                    <p dangerouslySetInnerHTML={{__html: detail?.address.replace(/\n/g, "<br />")}}></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.phone ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Phone':'โทรศัพท์'} :</h6>
                                                    <p>{detail?.phone}</p>
                                                </li> : ''
                                        }


                                        {
                                            detail?.email2 ?
                                                <li>
                                                    <h6>Email :</h6>
                                                    <p><a className="link-primary"
                                                          href={'mailto:' + detail?.email2}>{detail?.email2}</a></p>
                                                </li> : ''
                                        }
                                    </ul>
                                </div>

                                {
                                    detail?.googlemapUrl ?
                                        <div className="col-12">
                                            <div className="google-map h-300 mt-4">
                                                <iframe
                                                    src={detail?.googlemapUrl}
                                                    width="600" height="450" style={{border: 0}} allowFullScreen=""
                                                    loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                            </div>
                                        </div> : ''
                                }

                                <div className="col-12 pt-sm-5 pt-4">
                                    {
                                        educationListing !== null && educationListing.rows.length > 0 ?
                                                <div className="card-accordion">
                                                    <div className="card-header" data-bs-toggle="collapse"
                                                         data-bs-target="#collapseEducation" aria-expanded="false">
                                                        <h2>{prop.lang === 'en' ? 'Educational record':'ประวัติการศึกษา'}</h2>
                                                        <span className="arrow"></span>
                                                    </div>

                                                    <div id="collapseEducation" className="accordion-collapse collapse">
                                                        <div className="card-body">
                                                            {
                                                                educationListing.rows.map((row, index) => {
                                                                    return (
                                                                        <div key={index} className="mb-3">
                                                                            <h3>{prop.lang === 'en' ? row.institution_en:row.institution}</h3>
                                                                            <p className="mb-0">{prop.lang === 'en' ? 'Course/Major : ' + row.program_en:'หลักสูตร/สาขา : ' + row.program}</p>
                                                                            <p className="mb-0">{prop.lang === 'en' ? 'Degree : ' + row.level_en:'ระดับการศึกษา : ' + row.level}</p>
                                                                            <p className="mb-0">{prop.lang === 'en' ? 'Year of graduation : ' + row.year_en:'ปีที่จบการศึกษา : ' + row.year}</p>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div> : ''
                                    }

                                    {
                                        workListing !== null && workListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseWork" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Work history':'ประวัติการทำงาน'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseWork" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            workListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.company_en:row.company}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Position : ' + row.position_en:'ตำแหน่ง : ' + row.position}</p>
                                                                        {
                                                                            row.startDate ?
                                                                            <p className="mb-0">{prop.lang === 'en' ? 'Start Date : ' + Utils.dateTimeDMY(row.startDate):'วันที่เริ่มทำงาน : ' + Utils.dateTimeDMY(row.startDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.endDate ?
                                                                            <p className="mb-0">{prop.lang === 'en' ? 'End Date : ' + Utils.dateTimeDMY(row.endDate):'วันสิ้นสุดการทำงาน : ' + Utils.dateTimeDMY(row.endDate)}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        trainingListing !== null && trainingListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseTraining" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Training history':'ประวัติการฝึกอบรม'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseTraining" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            trainingListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.program_en:row.program}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Training Institute : ' + row.institution_en:'สถาบันที่จัดอบรม : ' + row.institution}</p>
                                                                        {
                                                                            row.startDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Start Date : ' + Utils.dateTimeDMY(row.startDate):'วันที่เริ่มอบรม : ' + Utils.dateTimeDMY(row.startDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.endDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'End Date : ' + Utils.dateTimeDMY(row.endDate):'วันสิ้นสุดการอบรม : ' + Utils.dateTimeDMY(row.endDate)}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        certificateListing !== null && certificateListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseCertificate" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Certificates and Diplomas':'ใบรับรองและประกาศนียบัตร'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseCertificate" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            certificateListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.program_en:row.program}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Name of institution : ' + row.institution_en:'ชื่อสถาบัน : ' + row.institution}</p>
                                                                        {
                                                                            row.startDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Date received : ' + Utils.dateTimeDMY(row.receivedDate):'วันที่ได้รับ : ' + Utils.dateTimeDMY(row.receivedDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.endDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Expiration date : ' + Utils.dateTimeDMY(row.expireDate):'วันหมดอายุ : ' + Utils.dateTimeDMY(row.expireDate)}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        intellectualListing !== null && intellectualListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseIntellectual" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Intellectual property':'ทรัพย์สินทางปัญญา'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseIntellectual" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            intellectualListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Issue No : ' + row.issueNo:'เลขที่คำขอ : ' + row.issueNo}</p>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Register No : ' + row.registerNo:'เลขที่จดทะเบียน : ' + row.registerNo}</p>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'URL : ':'ลิ้งค์ : '} <a href={row.url} target="_blank" className="text-primary">{prop.lang === 'en' ? 'Click':'คลิก'}</a></p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        awardListing !== null && awardListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseAward" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Awards received':'รางวัลที่ได้รับ'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseAward" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            awardListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        <p className="mb-0">{prop.lang === 'en' ? 'Providing agency : ' + row.institution_en:'หน่วยงานที่มอบ : ' + row.institution}</p>
                                                                        {
                                                                            row.receivedDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Award date : ' + Utils.dateTimeDMY(row.receivedDate):'วันทีรับรางวัล : ' + Utils.dateTimeDMY(row.receivedDate)}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        ongoingListing !== null && ongoingListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseOngoing" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Ongoing research':'งานวิจัยที่กำลังดำเนินการ'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseOngoing" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            ongoingListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        {
                                                                            row.startDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Start date : ' + Utils.dateTimeDMY(row.startDate):'วันเริ่มต้น : ' + Utils.dateTimeDMY(row.startDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.endDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'End date : ' + Utils.dateTimeDMY(row.endDate):'วันสิ้นสุด : ' + Utils.dateTimeDMY(row.endDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.researchGrant ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Research grants : ' + row.researchGrant_en:'ทุนวิจัย : ' + row.researchGrant}</p> : ''
                                                                        }
                                                                        {
                                                                            row.researchGrant ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Research funding agency : ' + row.institution_en:'หน่วยงานที่ให้ทุนวิจัย : ' + row.institution}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    {
                                        completedListing !== null && completedListing.rows.length > 0 ?
                                            <div className="card-accordion">
                                                <div className="card-header" data-bs-toggle="collapse"
                                                     data-bs-target="#collapseCompleted" aria-expanded="false">
                                                    <h2>{prop.lang === 'en' ? 'Completed research':'งานวิจัยที่ดำเนินการเสร็จแล้ว'}</h2>
                                                    <span className="arrow"></span>
                                                </div>

                                                <div id="collapseCompleted" className="accordion-collapse collapse">
                                                    <div className="card-body">
                                                        {
                                                            completedListing.rows.map((row, index) => {
                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                                        {
                                                                            row.startDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Start date : ' + Utils.dateTimeDMY(row.startDate):'วันเริ่มต้น : ' + Utils.dateTimeDMY(row.startDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.endDate ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'End date : ' + Utils.dateTimeDMY(row.endDate):'วันสิ้นสุด : ' + Utils.dateTimeDMY(row.endDate)}</p> : ''
                                                                        }
                                                                        {
                                                                            row.researchGrant ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Research grants : ' + row.researchGrant_en:'ทุนวิจัย : ' + row.researchGrant}</p> : ''
                                                                        }
                                                                        {
                                                                            row.researchGrant ?
                                                                                <p className="mb-0">{prop.lang === 'en' ? 'Research funding agency : ' + row.institution_en:'หน่วยงานที่ให้ทุนวิจัย : ' + row.institution}</p> : ''
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 